import { Link } from 'react-router-dom';
import { getGamesByCategory } from '@/mocks/games';
import GameCard from '@/components/base/GameCard';

export default function LiveCasino() {
  const liveGames = getGamesByCategory('zhenren-heguan');

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-900/40">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-live-line text-accent-400 text-lg"></i>
              </div>
              <span className="text-xs font-semibold text-accent-400 uppercase tracking-wider">LIVE CASINO</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              真人荷官
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg">
              专业真人荷官实时发牌，高清直播互动体验，身临其境感受真实赌场氛围。
            </p>
          </div>
          <Link
            to="/category/zhenren-heguan"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-product-shop="">
          {liveGames.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      </div>
    </section>
  );
}